import { FC } from "react";
import cx from "classnames";

import { CollaborationStatus } from "../../../../store/collaborators/types";
import { ReactComponent as SpinerIcon } from "../../../../assets/images/animations/spinner.svg";
import Icon, { IconTypes } from "./../../../../libs/Icon";

import styles from "./styles.module.scss";

interface IProps {
    status: CollaborationStatus;
}

const Status: FC<IProps> = ({ status }) => {
    switch (status) {
        case CollaborationStatus.Approved:
            return (
                <span className={cx(styles.status, styles.approved)}>
                    <Icon type={IconTypes.VERIFIED} size={16} /> <span>Approved</span>
                </span>
            );

        case CollaborationStatus.Pending:
            return (
                <span className={cx(styles.status, styles.pending)}>
                    <SpinerIcon /> <span>Pending Invitation</span>
                </span>
            );

        default:
            return null;
    }
};

export default Status;
